import { get } from 'lodash'

const LOCAL = 'local'
const STAGING = 'staging'
const PRODUCTION = 'production'

/**
 * Doorstep's base template injects envirnoment variables into the window.
 * This returns an envirnoment enum string by inspecting the doorstep injected
 * flags.
 */
/* tslint:disable-next-line:variable-name */
export const fromDoorstepInjectedEnvironment = (_window = window) => {
  if (get(_window, 'view.STAGING')) {
    return STAGING
  }

  if (get(_window, 'view.PRODUCTION')) {
    return PRODUCTION
  }

  return LOCAL
}

export const isProduction = environment => environment === PRODUCTION
export const isLocal = environment => environment === LOCAL
export const isStaging = environment => environment === STAGING
